import axios from 'axios';

const baseUrl = "/api/SiteSearch";
class SearchKeywordService {
    private language: string;

    public constructor(language: string) {
        this.language = language;
    }

    public getKeywords(query: string) {
        const encodedQuery = encodeURI(query);
        return axios.get(`${baseUrl}/Keywords?query=${encodedQuery}&language=${this.language}`)
            .then((response) => response.data);
    }

}

export { SearchKeywordService };
